import gql from 'graphql-tag'

export const QUERY_GET_FINAL_CONSUMER_CATEGORIES = gql`
  query CategoriesFinalConsumer($search: String) {
    categoriesFinalConsumer(search: $search) {
      departments {
        _id
        name
        image
      }
      categories {
        _id
        name
        image
        department_id
      }
      sub_categories {
        _id
        name
        image
        category_id
      }
    }
  }
`
